export default {"src":"/_next/static/media/Group_42542.729fd8b8.svg","height":78,"width":83};